<!--
 * @Descripttion: 海报数据报表
 * @version: 
 * @Author: alex.yang
 * @Date: 2022-07-04 10:56:14
 * @LastEditors: alex.yang
 * @LastEditTime: 2023-05-22 16:38:26
-->
<template>
    <div class="posterDataReport">
        <div class="title-wrap">
            <div class="tag"></div>
            <div class="title">3D全景使用报表</div>
        </div>
        <div class="case-wrap">
            <div class="screen-wrap">
                <commonSelect
                    @changeDate="changeDate"
                    @clickTagDate="clickTagDate"
                ></commonSelect>
            </div>
            <div class="t-wrap">
                <div class="t-item">
                    <el-select filterable clearable v-model="ep_id" 
                        @change="selectEpChange" placeholder="请选择品牌筛选">
                        <el-option
                            v-for="item in epOptions"
                            :key="item.ep_id"
                            :label="item.name"
                            :value="item.ep_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="t-item" v-if="ep_id != ''">
                    <el-select filterable clearable v-model="shop_id" 
                        @change="selectShopChange" placeholder="请选择门店筛选">
                        <el-option
                            v-for="item in shopOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="case-wrap data-collect" v-loading="loading1">
            <div class="title-wrap">
                <div class="tag"></div>
                <div class="title">数据汇总</div>
            </div>
            <div class="content-wrap">
                <div class="item">
                    <span>{{basicData.open_count}}</span>打开数
                </div>
                <div class="item">
                    <span>{{basicData.store_count}}</span>保存数
                </div>
                <div class="item">
                    <span>{{basicData.share_count}}</span>分享数
                </div>
            </div>
        </div>
        <div class="case-wrap share-collect" v-loading="loading2">
            <div class="title-wrap">
                <div class="tag"></div>
                <div class="title">使用分析</div>
            </div>
            <div class="share-wrap">
                <div id="panoramaGrades" style="width: 100%;height: 390px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import pageMixin from '@/internal/pageMixin'
import common from "@/utils/common.js"
import commonSelect from "@/components/commonSelect.vue"
import {panoramaLineEcharts} from "@/echarts/lineEchartData";
export default {
    components: {
        commonSelect
    },
    mixins:[pageMixin],
    data () {
        return {
            pageMixin_index:'panoramaReport',
            dateType: '',
            startDate: '',
            endDate: '',
            basicData: {},
            loading1: false,
            loading2: false,
            epOptions: [],
            ep_id: '',
            shop_id: '',
            shopOptions: [],
        }
    },
    mounted () {
        this.getEpConditions();
        this.getShopConditions();
        this.getDataReport();
        this.getPosterLineChart();
    },
    methods: {
        // 获取门店下拉数据
        getShopConditions(){
            common.connect('/customerservicev1/shop/allShopConditions',{ep_id: this.ep_id},(res)=>{
                this.shopOptions = res.data
            })
        },
        // 获取品牌下拉数据
        getEpConditions(){
            common.connect('/customerservicev1/enterprise_brand/EpConditions',{},(res)=>{
                this.epOptions = res.data
            })
        },
        selectShopChange(){
            this.getDataReport();
            this.getPosterLineChart();
        },
        selectEpChange(){
            this.getDataReport();
            this.getPosterLineChart();
            this.getShopConditions();
        },
        // 获取海报分享数据
        getPosterLineChart(){
            let params = {
                date_type: this.dateType,
                start_date: this.startDate,
                end_date: this.endDate,
                ep_id: this.ep_id,
                shop_id: this.shop_id
            }
            this.loading2 = true;
            common.connect("/customerservicev1/data_report/scene3DUseLogLineChart",params,(res)=>{
                panoramaLineEcharts('panoramaGrades',res.data);
                this.loading2 = false;
            });
        },
        // 获取基本数据
        getDataReport(){
            let params = {
                date_type: this.dateType,
                start_date: this.startDate,
                end_date: this.endDate,
                ep_id: this.ep_id,
                shop_id: this.shop_id
            }
            this.loading1 = true;
            common.connect("/customerservicev1/data_report/scene3DReport",params,(res)=>{
                this.basicData = res.data;
                this.loading1 = false;
            });
        },
        // 日期选择
        changeDate(startDate,endDate){
            this.startDate = startDate.slice(0,11)+' 00:00:01';
            this.endDate = endDate.slice(0,11)+' 23:59:59';
            this.getDataReport();
            this.getPosterLineChart();
        },
        clickTagDate(item){
            this.dateType = item.label;
            if(item.label != 'date'){
                this.startDate = '';
                this.endDate = '';
                this.getDataReport();
                this.getPosterLineChart();
            }
        },
    },
}
</script>

<style lang='scss'>
.posterDataReport{
    background: rgb(240, 242, 245);
    padding: 10px 25px;
    height: calc(100vh - 80px);
    overflow-y: auto;
    .title-wrap{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 5px 0;
        .tag{
            width: 4px;
            height: 20px;
            background: #409EFF;
            border-radius: 10px;
        }
        .title{
            font-size: 18px;
            font-weight: bold;
            padding-left: 10px;
        }
    }
    .case-wrap{
        background: #fff;
        padding: 20px;
        margin: 20px 0;
        border-radius: 6px;
        .t-wrap{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            padding-top: 15px;
            .t-item{
                margin-right: 15px;
            }
        }
        .title-wrap{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin: 5px 0;
            .tag{
                width: 3px;
                height: 15px;
                background: #409EFF;
                border-radius: 10px;
            }
            .title{
                font-size: 16px;
                font-weight: bold;
                padding-left: 10px;
            }
        }
    }
    .data-collect{
        .content-wrap{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            .item{
                border: 1px solid #ddd;
                border-radius: 6px;
                width: 30%;
                display: flex;
                justify-content: center;
                align-items: baseline;
                height: 120px;
                line-height: 120px;
                span{
                    font-size: 26px;
                    font-weight: bold;
                    color: #000000;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>
